<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 09:50:09
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:03:15
 * @name: 完善信息
 * @Description: 完善信息
 * @FilePath: \preSaleNafterSaleBackstage\src\components\register\set-info.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="registerSetInfo">
    <div class="content">
      <div class="line">
        <font class="label">组织名称:</font>
        <el-input
          class="input"
          :value="register.name"
          @input="nameInput"
          placeholder="请输入组织名称"
          clearable
        />
      </div>
      <div class="line">
        <font class="label">所在地:</font>
        <div class="seletGroup">
          <el-select v-model="provinceSelected" placeholder="请选择省份">
            <el-option
              v-for="item in province"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-select v-model="citySelected" placeholder="请选择城市">
            <el-option
              v-for="item in city"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="line">
        <font class="label">行业类型:</font>
        <el-select
          class="input"
          :value="register.type"
          @change="typeChange"
          placeholder="请选择行业类型"
        >
          <el-option
            v-for="item in register.typeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="line">
        <font class="label">登录密码:</font>
        <el-input
          class="input"
          type="password"
          :value="register.password"
          @input="passwordInput"
          placeholder="请输入登录密码"
          clearable
        />
      </div>
      <font class="tips">密码必须为6位以上数字、大小写字母组合</font>
      <div class="line">
        <font class="label">联系人姓名:</font>
        <el-input
          class="input"
          :value="register.realname"
          @input="realnameInput"
          placeholder="请输入联系人姓名"
          clearable
        />
      </div>
      <el-button class="submit" type="primary" @click="submit"
        >提交申请</el-button
      >
    </div>
  </div>
</template>
<script>
import regionSelect from "@/mixins/regionSelect";
import { debounceation } from "@/utils/decorator";

export default {
  name: "registerSetInfo",
  mixins: [regionSelect],
  props: {
    register: {
      type: Object,
    },
    step: {
      type: Number,
      default: 2,
    },
  },
  watch: {
    provinceSelected: {
      handler(nv, ov) {
        this.register.province = nv;
      },
      immediate: true,
      deep: true,
    },
    citySelected: {
      handler(nv, ov) {
        this.register.city = nv;
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.init();
    this.register.getTypeList();
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 输入组织名称
     * @param {String} e 组织名称
     */
    nameInput(e) {
      this.register.name = e;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 选择行业类型
     * @param {Number} e 行业类型
     */
    typeChange(e) {
      this.register.type = e;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 输入登录密码
     * @param {String} e 登录密码
     */
    passwordInput(e) {
      this.register.password = e;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 输入联系人姓名
     * @param {String} e 联系人姓名
     */
    realnameInput(e) {
      this.register.realname = e;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 重置
     */
    init() {
      this.register.name = "";
      this.register.province = "";
      this.register.city = "";
      this.register.type = "";
      this.register.password = "";
      this.register.realname = "";
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击提交申请
     */
    @debounceation(300)
    submit() {
      this.register.submit().then((res) => {
        this.$emit("update:step", 3);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
$labelWidth: 100px;
$inputWidth: 400px;
$margin: 30px;
$padding: $margin;

.registerSetInfo {
  @extend .extend-flex-center;
  .content {
    padding: $padding 0;
    @extend .extend-flex-column-normal;
    .line {
      margin-bottom: $margin;
      @extend .extend-flex-start;
      .label {
        width: $labelWidth;
        flex-shrink: 0;
        font-size: $Vars-font-miniTitle-size;
      }
      .input {
        width: $inputWidth;
        flex-shrink: 0;
      }
      .seletGroup {
        width: $inputWidth;
        flex-shrink: 0;
        @include grid-column(2, 190px, 20px);
      }
    }
    .tips {
      margin-bottom: $margin;
      margin-left: $labelWidth;
      font-size: $Vars-font-secondary-size;
      color: $Vars-font-placeholder-color;
    }
    .submit {
      width: 120px;
      align-self: center;
    }
  }
}
</style>